import React from "react";
import "../../../../App.css";
import SideBar from "components/layout/sidebar/Sidebar";
import DashboardNavBar from "components/layout/DashboardNavBar";
import EditEquipment from "./Edit";

const CallEditEquipment = ({ match }) => {
  return (
    <div>
      <DashboardNavBar />
      <SideBar />
      <EditEquipment idItem={match.params.id}/>
    </div>
  );
}

export default CallEditEquipment;